import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getQuestReportDirectSaleXFinancial } from './DirectSaleXFinancial.service';

export function useDirectSaleXFinancialReport() {
  return useMutation(getQuestReportDirectSaleXFinancial, {
    onSuccess() {
      notification.success({
        message: 'O relatório VD x Financeiro foi gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
